import script from "./ClientBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientBlock.vue?vue&type=script&setup=true&lang=js"

import "./ClientBlock.vue?vue&type=style&index=0&id=685116bd&lang=scss"

const __exports__ = script;

export default __exports__